<template>
    <v-snackbar v-model="show" :timeout="timeout" :color="color" outlined>

        <p class="mb-1 text-center">
            {{ text }}
        </p>

        <p class="mb-1" v-for="item in items" :key="item">
            {{ item }}
        </p>

        <template v-slot:action="{ attrs }">
            <v-btn :color="color" icon v-bind="attrs" @click="show = false">
               <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>

    </v-snackbar>
</template>


<script>

export default {


    data: () => ({

        show: false,
        color: 'success',
        text: '',
        items: [],
        timeoutUnit: 2500,
    }),

    mounted() {
        window.Feedback = {};
        window.Feedback.Success = this.success;
        window.Feedback.Error = this.error;
        window.Feedback.ErrorResponse = this.errorResponse;
        window.Feedback.Feedback = this.feedback;
    },

    computed: {
        timeout: function() {
            return this.timeoutUnit * (this.items.length + 1);
        },
    },

    methods: {
        success(text, items = []) {
            this.feedback('success', text, items);
        },

        error(text, items = []) {
            this.feedback('error', text, items);
        },

        errorResponse(response) {

            // permission error
            if (response.response.status === 403) {
                this.error('Action denied.');

            // validation error
            } else if (response.response.status === 422) {
                let errors = response.response.data.errors;
                let items = [];

                Object.keys(errors).forEach(function(key) {
                    items.push(errors[key][0]);
                });

                this.error(response.response.data.message, items);

            // other errors
            } else {
                this.error(response.message);
            }

        },

        feedback(color, text, items) {
            this.color = color;
            this.text = text;
            this.items = items;
            this.show = true;
        },
    },

};
</script>
